var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
let UcTimer = class UcTimer extends Vue {
  created() {
    this.$watch(() => this.times, t => {
      this.timesLeft = t;
      this.reset();
    });
    this.$watch(() => this.interval, () => {
      this.reset();
    });
    this.timesLeft = this.times;
    this.reset();
  }
  beforeDestroy() {
    this.shutdown();
    this.timesLeft = 0;
  }
  /** 关闭定时器 */
  shutdown() {
    if (this.currentTimer) clearTimeout(this.currentTimer);
    this.currentTimer = null;
  }
  /** 重置定时器 */
  reset() {
    this.shutdown();
    const queueNextTick = () => {
      // 这很重要！设计模式下不需要触发！
      if (this.$attrs['data-uc-design-mode']) return;
      if (this.interval <= 0) return;
      if (this.timesLeft === 0) return;
      this.currentTimer = setTimeout(async () => {
        this.currentTimer = null;
        try {
          var _this$handleTick;
          this.$emit('handleTick'); // 一个兼容性bug
          await ((_this$handleTick = this.handleTick) === null || _this$handleTick === void 0 ? void 0 : _this$handleTick.call(this));
        } catch (e) {
          console.error('[UICore] Timer met error', e);
        }
        // 如果限制了执行次数，则次数要 -1
        if (this.timesLeft > 0) this.timesLeft -= 1;
        queueNextTick();
      }, Math.floor(this.interval * 1000));
    };
    queueNextTick();
  }
};
__decorate([Prop()], UcTimer.prototype, "interval", void 0);
__decorate([Prop({
  default: -1
})], UcTimer.prototype, "times", void 0);
__decorate([Prop({
  default: null
})], UcTimer.prototype, "handleTick", void 0);
UcTimer = __decorate([Component({
  name: 'UcTimer'
})], UcTimer);
const TimerComponentMeta = {
  id: 'uc-timer',
  type: 'trigger',
  name: '定时触发',
  component: UcTimer,
  events: [{
    id: ':handleTick',
    name: '到达触发时刻'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'interval',
      title: '间隔（秒）',
      type: 'number',
      required: true
    }, {
      id: 'times',
      title: '次数',
      type: 'number',
      required: true,
      default: -1,
      description: '-1 表示无限次； 0 表示禁用定时器'
    }]
  },
  getLayoutName(layout) {
    const {
      interval,
      times
    } = layout.props || {};
    if (!interval) return '待配置定时器';
    if (typeof interval !== 'number') return '定时触发';
    return `间隔${interval}秒触发${typeof times === 'number' ? `${times}次` : ''}`;
  }
};
export default TimerComponentMeta;